import React, { useMemo } from 'react';
import { Box, Typography, Button, Alert, AlertTitle, Stack, IconButton } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import nxLogo from 'assets/images/nxLogo.png';
import { useHistory } from 'react-router-dom';

const CAT_MESSAGES = [
  'Something went wrong. The cats are on it.',
  "This page has gone to the dogs... wait, we mean cats.",
  "Our cats are investigating. Please try again later.",
  "Error: cat not found. (Just kidding — here's a cat.)",
  "Something broke. Have a cat while we fix it.",
];

const SurveyError = () => {
  const supportEmail = 'professionals@newtonx.com';
  const history = useHistory();
  const { catMessage, catImageUrl } = useMemo(
    () => ({
      catMessage: CAT_MESSAGES[Math.floor(Math.random() * CAT_MESSAGES.length)],
      catImageUrl: `https://cataas.com/cat?width=400&height=300&t=${Math.random()}`,
    }),
    []
  );
  const copyToClipboard = () => {
    navigator.clipboard.writeText(supportEmail);
  };

  return (
    <Box
      maxWidth="680px"
      margin="0 auto"
      padding="40px 24px"
      textAlign="center"
      display="flex"
      flexDirection="column"
      alignItems="center"
    >
      <img src={nxLogo} alt="NewtonX logo" style={{ height: '56px', marginBottom: '32px' }} />

      <Typography variant="h1" fontWeight={700} marginBottom={'32px'}>
        {catMessage}
      </Typography>
      <img
        src={catImageUrl}
        alt="A cat"
        style={{ maxWidth: '400px', width: '100%', borderRadius: '8px', marginBottom: '32px' }}
      />
      <Typography variant="body1" color="text.secondary" marginBottom="32px">
        We encountered an unexpected issue while processing your request. This might be a temporary
        problem that we're working to resolve.
      </Typography>

      <Alert
        severity="warning"
        icon={<WarningAmberIcon fontSize="inherit" />}
        sx={{ textAlign: 'left', marginBottom: '32px', backgroundColor: 'rgba(255, 224, 178, 1)' }}
      >
        <AlertTitle>What Happened?</AlertTitle>
        Our system experienced a technical issue. This could be due to high traffic, a temporary
        server problem, or a connectivity issue. Your data and progress are safe.
      </Alert>
      <Typography variant="h3" fontWeight={700} marginBottom={'16px'}>
        What can you do?
      </Typography>
      <Button
        variant="contained"
        color="primary"
        fullWidth
        sx={{ marginBottom: '16px' }}
        onClick={() => history.goBack()}
      >
        TRY AGAIN
      </Button>

      <Typography variant="body1" marginBottom="8px">
        Need to contact us? You can reach out to us at:
      </Typography>

      <Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
        <Typography variant="body1" fontWeight={700}>
          {supportEmail}
        </Typography>
        <IconButton onClick={copyToClipboard} size="small" sx={{ padding: '2px' }}>
          <ContentCopyIcon fontSize="small" />
        </IconButton>
      </Stack>
    </Box>
  );
};

export default SurveyError;
